import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import CloseIcon from "./assets/CloseIcon.svg";
import { INITPAGING } from "../based/Constants";
import OrderServices from "../based/services/OrderServices";
import CommonTablePagination from "../based/CommonTablePagination";

function PlatformProductModal({ show, onClose, designId, shopId, platform, onSave }) {
    const [listProduct, setListProduct] = useState([]);
    const [pageModel, setPageModel] = useState({ ...INITPAGING, shopId: shopId, platform: platform });
    const [loading, setLoading] = useState(false);
    const [tabId, setTabId] = useState(0);

    useEffect(() => {
        getLstProduct(pageModel);
    }, []);

    const getLstProduct = async (page) => {
        setLoading(true);
        const [err, data] = await OrderServices.GetListProductModel(page);
        if (!err && data) {
            setListProduct(data.listObjects);
            setPageModel(data.paging);
        } else {
            setPageModel(page);
        }
        setLoading(false);
    };

    function handleChangePage(page) {
        let newPaging = {
            ...pageModel,
            pageNumber: page,
        };
        getLstProduct(newPaging);
    }

    function handleChangePageSize(pageSize) {
        let newPaging = {
            ...pageModel,
            pageNumber: 1,
            pageSize: pageSize,
        };
        getLstProduct(newPaging);
    }

    return (
        <CommonModal show={show} onClose={onClose} hiddenFooter hideClose size="lg" isBusy={loading}>
            <Wrapper>
                <section className="header-modal">
                    <h4>Chọn sản phẩm muốn đồng bộ</h4>
                    <div className="icon" onClick={onClose}>
                        <img src={CloseIcon} alt="" />
                    </div>
                </section>
                <section className="body-modal">
                    <div className="list-product">
                        {listProduct &&
                            listProduct.length > 0 &&
                            listProduct.map((item, index) => {
                                return (
                                    <div
                                        onClick={(e) => {
                                            setTabId(item.platformProductId);
                                        }}
                                        className={`product-item ${item.platformProductId == tabId ? "active" : ""}`}
                                        key={index}
                                    >
                                        <div className="product-image">
                                            <img src={item.productAvatar} alt="" />
                                        </div>
                                        <div className="product-name">
                                            <span>
                                                {item.platformProductId} - {item.name}
                                            </span>
                                        </div>
                                        <div className="product-price"></div>
                                    </div>
                                );
                            })}
                    </div>
                    <div className="table-bottom">
                        <CommonTablePagination paging={pageModel} onChangePage={handleChangePage} onChangePageSize={handleChangePageSize} />
                    </div>
                </section>
                <section className="bottom-btn">
                    <div className="lst-btn">
                        <button
                            className="btn btn-close"
                            onClick={(e) => {
                                onClose();
                            }}
                        >
                            Đóng
                        </button>
                        <button
                            className="btn btn-orange"
                            onClick={(e) => {
                                onSave(tabId);
                            }}
                        >
                            Chọn
                        </button>
                    </div>
                </section>
            </Wrapper>
        </CommonModal>
    );
}

export default PlatformProductModal;

const Wrapper = styled.div`
    section.header-modal {
        display: flex;
        align-items: center;
        padding: 24px;
    }

    section.header-modal .icon {
        margin-left: auto;
    }

    section.header-modal h4 {
        color: #333;
        text-align: center;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin: 0 0 0 auto;
    }

    section.body-modal {
        padding: 24px;
    }

    .list-action {
        display: flex;
        align-items: center;
    }

    .list-product {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .product-item {
        min-width: 160px;
        height: auto;
        margin: 8px 16px;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        width: calc(20% - 32px);
    }

    .product-image {
        width: 100%;
        height: 100%;
    }

    .product-image img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .product-name {
        margin: 9px;
        color: #303030;
        font-size: 12px;
        font-style: normal;
        font-family: Lexend;
        font-weight: 400;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .product-price {
        padding: 9px;
        overflow: hidden;
        color: #303030;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .product-item.active {
        border-radius: 8px;
        border: 1px solid #ff9027;
        background: #ffe8d3;
    }

    .product-item.active .product-price {
        overflow: hidden;
        color: #ff9027;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    section.bottom-btn {
        display: flex;
        padding: 14px;
        border: 1px solid #f3f3f3;
        background: #fff;
        box-shadow: 0px -2px 30px 0px rgba(0, 0, 0, 0.1);
    }

    .lst-btn {
        margin-left: auto;
        display: flex;
    }

    .lst-btn .btn-close {
        border-radius: 40px;
        border: 1px solid #e5e5e5;
        background: #f3f3f3;
        margin: 0 10px;
        width: 140px;
    }

    .lst-btn .btn-orange {
        border-radius: 40px;
        background: #ff9027;
        color: #fff;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        width: 140px;
    }
`;
